import React from 'react';
import {Document, Font} from '@react-pdf/renderer';
import {getPdfFonts} from "../../utils/themePdfUtils";
import {getThemeName} from "../../utils/themeUtils";
import AMBBoardingPassPage from "./AMBBoardingPassPage";
import AMBEventBoardingPassPage from "./AMBEventBoardinPassPage";
import {isEventSubType} from "../../utils/miscUtils";
import CFCBoardingPassPage from './CFCBoardingPassPage';
import { t } from '@lingui/core/macro';

Font.register({
    family: "pdfFont",
    fonts: getPdfFonts(),
});

function BoardingPassPdf(props) {
    return (
        <Document title={t({id: "boarding_pass"})}>
            {props.passengers.map((passenger, index) =>
                <BoardingPassPage key={passenger.passengerId}
                    passenger={passenger}
                    bookingData={props.bookingData}
                    passengerNr={index}
                />
            )}
        </Document>
    );
}

export default BoardingPassPdf;


const BoardingPassPage = (props) => {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            if(isEventSubType(props.bookingData.bookingSubType)) {
                return <AMBEventBoardingPassPage {...props} />;
            }

            return <AMBBoardingPassPage {...props} />
        
        case "cfc":
            return <CFCBoardingPassPage {...props}/>

        default:
            return <AMBBoardingPassPage {...props}/>
    }
}